import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable, of, BehaviorSubject } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Vendor } from '../../../models/common/vendor';
import { apiUrl } from '../../../config/api-url';

export interface IPrivateLabelData {
  is_private_label: boolean;
  manufacturer: Vendor;
}

@Injectable({
  providedIn: 'root'
})
export class PrivateLabelService {

  public isPrivateLabel$: Observable<boolean>;

  private data: IPrivateLabelData = { is_private_label: false, manufacturer: null };
  private isPrivateLabelSubject = new BehaviorSubject<boolean>(true);

  constructor() {
    this.isPrivateLabel$ = this.isPrivateLabelSubject.asObservable();
  }

  public setData(data: IPrivateLabelData): void {
    this.data = data;
    this.isPrivateLabelSubject.next(data.is_private_label);
  }

  public get manufacturer() {
    return this.data ? this.data.manufacturer : null;
  }

  public get isPrivateLabel() {
    return this.data ? this.data.is_private_label : false;
  }
}
